export const ACTION_TYPES: {
  FREE: 'FREE';
  astra_marine: 'astra_marine';
  certificate: 'certificate';
  partner_widget: 'partner_widget';
  purchase: 'purchase';
  reservation: 'reservation';
  tsnext_widget: 'tsnext_widget';
} = {
  certificate: 'certificate',
  purchase: 'purchase',
  reservation: 'reservation',
  FREE: 'FREE',
  partner_widget: 'partner_widget',
  astra_marine: 'astra_marine',
  tsnext_widget: 'tsnext_widget',
};

export type ActionType = keyof typeof ACTION_TYPES;
